import React, { useContext } from 'react';
import { Button } from 'react-bootstrap';
import { WidgetContext } from '../../../../../../context/WidgetContext';

interface AddItineraryUnitButtonProps {
  /** label of the button */
  buttonText: string;
  /** onClick function for the button */
  onClick: () => void;
  /** button color */
  buttonColor?: string;
  /** marginTop which is defaulted to 15px */
  marginTop?: string;
  /** button height which is defaulted to 30px */
  height?: string;
}

const AddItineraryUnitButton: React.FC<AddItineraryUnitButtonProps> = ({
    buttonText,
    onClick,
    buttonColor,
    marginTop = '15px',
    height = '30px',
}) => {
    const {style} = useContext(WidgetContext);
    
    /** if no button color is passed in assign the style color */
    if (!buttonColor) {
      buttonColor = style.itineraryButtonColor
    }

    return (
        <div className="d-flex flex-row justify-content-end">
            <Button
                size="sm"
                style={{
                    backgroundColor: buttonColor,
                    border: "none",
                    marginTop: marginTop,
                    height: height,
                }}
                onClick={onClick}
            >
                {buttonText}
            </Button>
        </div>
    );
};

export default AddItineraryUnitButton;